import React from "react";
// Real <button>, focus ring, aria-label, 44px touch target (DESIGN.md §5).
export function IconButton({ label, onClick, className, disabled, pressed, expanded, type = "button", title, children }) {
    return (<button type={type} aria-label={label} title={title ?? label} aria-pressed={pressed} aria-expanded={expanded} onClick={onClick} disabled={disabled} className={`
                inline-flex items-center justify-center rounded-lg p-1.5 cursor-pointer
                pressable focus-ring tap-target
                disabled:cursor-not-allowed disabled:opacity-40
                ${className ?? ""}
            `}>
            {children}
        </button>);
}
export default IconButton;
//# sourceMappingURL=iconButton.jsx.map